// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.editable-list[data-v-287ec464] {\n  display: flex;\n  flex-direction: column;\n}\n.editable-list > .display-flex[data-v-287ec464] {\n  flex-wrap: wrap;\n}\n.editable-list > .list-item + .list-item[data-v-287ec464] {\n  border-top: 1px solid #f4f5f8;\n}\n.editable-list > .error-message[data-v-287ec464] {\n  font-size: 1rem;\n  padding: 1rem 2rem;\n  display: block;\n}\n.ui-dropdown[data-v-287ec464] {\n  margin: 0.5rem 1rem 0.5rem 2rem;\n}\n", ""]);
// Exports
module.exports = exports;
